import { interpret } from 'xstate';

import { authMachine } from './auth.machine';

const DEV_MODE = process.env.NODE_ENV === 'development';

export const authService = interpret(authMachine, { devTools: DEV_MODE }).start();

export type AuthService = typeof authService;
